module.exports = __WEBPACK_EXTERNAL_MODULE_80__;


//////////////////
// WEBPACK FOOTER
// external {"root":"numbro","commonjs2":"numbro","commonjs":"numbro","amd":"numbro"}
// module id = 80
// module chunks = 0